import { isValidElement } from 'react';
import { isReactComponent } from '../is-react';
export function isCustomView(obj) {
  if (!obj) {
    return false;
  }
  return /*#__PURE__*/isValidElement(obj) || isReactComponent(obj);
}